<template>
    <div class="main-div">
        <HeaderRemove @closeDialog="closeDialog" />
        <MainRemove />
        <FooterRemove @closeDialog="closeDialog" />
    </div>
</template>
<script setup lang="ts">
import { getDialogRef } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';
import FooterRemove from './FooterRemove.vue';
import HeaderRemove from './HeaderRemove.vue';
import MainRemove from './MainRemove.vue';

const dialogRef = getDialogRef(ModalNames.REMOVE_CONTACT);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply w-[90%] max-w-[90%] lg:w-[544px] lg:max-w-[544px] flex flex-col items-center self-stretch rounded-[8px] bg-[#ffffff] shadow-[0px_20px_24px_-4px_rgba(10,13,18,0.08),_0px_8px_8px_-4px_rgba(10,13,18,0.03),_0px_3px_3px_-1.5px_rgba(10,13,18,0.04)];
    @apply fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50;
}
</style>
